import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem
} from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { useEffect, useRef, useState } from 'react'
import toastError from '../../errors/toastError'
import useAuth from '../../hooks/useAuth.js'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import OnlyForSuperUser from '../OnlyForSuperUser'
import SelectInput from '../SelectInput'
import ClosingReasonCreationModal from './ClosingReasonModal'
import { useStyles } from './styles'

const ClosingReasonModal = ({ open, onClose, onConfirm, ticket }) => {
  const classes = useStyles()
  const [closingReasons, setClosingReasons] = useState([])
  const [selectedReasonId, setSelectedReasonId] = useState('')
  const [, setSelectedReason] = useState(null)
  const [loading, setLoading] = useState(false)
  const [createModalOpen, setCreateModalOpen] = useState(false)
  const isMounted = useRef(true)

  const [currentUser, setCurrentUser] = useState({})
  const { getCurrentUserInfo } = useAuth()

  useEffect(() => {
    isMounted.current = true
    getCurrentUserInfo().then(u => {
      if (isMounted.current) {
        setCurrentUser(u)
      }
    })
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (open) {
      fetchClosingReasons()
    }
  }, [open, ticket?.queueId])

  const fetchClosingReasons = async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams()

      // Se o ticket tem um departamento/queue vinculado, filtrar por ele
      if (ticket?.queueId) {
        params.append('queueId', ticket.queueId)
      }

      const url = `/closing-reasons/list${
        params.toString() ? `?${params.toString()}` : ''
      }`
      const { data } = await api.get(url)
      if (isMounted.current) {
        setClosingReasons(data)
      }
    } catch (err) {
      toastError(err)
    }
    if (isMounted.current) {
      setLoading(false)
    }
  }

  const handleReasonChange = event => {
    const reasonId = event.target.value
    setSelectedReasonId(reasonId)

    const reason = closingReasons.find(r => r.id === reasonId)
    setSelectedReason(reason)
  }

  const handleConfirm = () => {
    if (!selectedReasonId) {
      return
    }

    onConfirm(selectedReasonId)
  }

  const handleClose = (event, reason) => {
    setSelectedReasonId('')
    setSelectedReason(null)
    onClose()
  }

  const handleOpenCreateModal = () => {
    setCreateModalOpen(true)
  }

  const handleCloseCreateModal = () => {
    setCreateModalOpen(false)
    // Recarregar a lista de motivos após criar um novo
    if (open) {
      fetchClosingReasons()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        {/* {i18n.t('closingReasonModal.title')} */}
        Motivo de Finalização do Atendimento
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.selectContainer}>
          <SelectInput
            label={i18n.t('closingReasonModal.subtitle')}
            value={selectedReasonId}
            onChange={handleReasonChange}
            displayEmpty
          >
            {closingReasons.map(reason => (
              <MenuItem key={reason.id} value={reason.id}>
                {reason.name}
              </MenuItem>
            ))}
          </SelectInput>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <ButtonPrimary
                className={classes.createButton}
                startIcon={<Add />}
                onClick={handleOpenCreateModal}
                label={i18n.t('closingReasonModal.createNew')}
              />
            )}
          />
        </div>

        {/* {selectedReason && selectedReason.description && (
          <Box className={classes.description}>
            <Typography variant="body2">
              <strong>{i18n.t('closingReasonModal.description')}:</strong>
            </Typography>
            <Typography variant="body2">
              {selectedReason.description}
            </Typography>
          </Box>
        )} */}
      </DialogContent>
      <DialogActions>
        <ButtonSecondary
          onClick={handleClose}
          label={i18n.t('closingReasonModal.cancel')}
        />
        <ButtonPrimary
          onClick={handleConfirm}
          disabled={!selectedReasonId || loading}
          label={i18n.t('closingReasonModal.confirm')}
        />
      </DialogActions>

      <ClosingReasonCreationModal
        open={createModalOpen}
        onClose={handleCloseCreateModal}
        defaultQueueId={ticket?.queueId}
      />
    </Dialog>
  )
}

export default ClosingReasonModal
